<template>
  <b-form>
    <b-row>
      <b-col md="3">
        <b-form-group label="Featured Menu">
          <b-select
            v-model="featuredMenuId"
            :disabled="!canCDMenuEdit">
            <b-select-option :value="null">
              -- None --
            </b-select-option>
            <b-select-option
              v-for="item in allMenuItems"
              :key="item.id"
              :value="item.id">
              {{ item.page }}
            </b-select-option>
          </b-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md>
        <c-d-menu-list
          v-if="config.left"
          ref="leftList"
          v-model="config.left"
          header="Left Menu"
          @delete-item="onRemoveMenuItem" />
      </b-col>
      <b-col
        md
        class="mt-3 mt-md-0">
        <c-d-menu-list
          v-if="config.right"
          ref="rightList"
          v-model="config.right"
          header="Right Menu"
          @delete-item="onRemoveMenuItem" />
      </b-col>
    </b-row>
    <b-btn
      v-if="canCDMenuEdit"
      variant="outline-primary"
      class="mt-3"
      @click="onAddMenuItem">
      + Add Menu Item
    </b-btn>
  </b-form>
</template>

<script>
import CDMenuList from "@/components/CDMenu/CDMenuList"
import ConfirmRemoval from "@/mixins/ConfirmRemoval"
import uuid from "uuid"
import {mapGetters} from "vuex"

export default {
  name: "CDMenuForm",
  components: {
    CDMenuList,
  },
  mixins: [
    ConfirmRemoval,
  ],
  props: {
    value: {
      type: Object,
      default: () => ({
        featured: null,
        left: [],
        right: [],
      }),
    },
  },
  data: () => ({
    featuredMenuId: null,
  }),
  computed: {
    ...mapGetters([
      "canCDMenuEdit",
    ]),
    config: {
      get: function () {
        return this.value
      },
      set: function (value) {
        this.$emit("input", value)
      },
    },
    allMenuItems() {
      const left = this.config.left || []
      const right = this.config.right || []
      return left.concat(right)
    },
  },
  watch: {
    "config.featured"(newVal) {
      if (newVal) {
        const featuredMenu = this.allMenuItems.find(it => it.page === this.config.featured)
        if (featuredMenu) {
          this.featuredMenuId = featuredMenu.id
        }
      }
    },
    featuredMenuId(newVal) {
      if (!newVal) {
        this.config.featured = null
      }

      const menu = this.allMenuItems.find(it => it.id === newVal)
      if (menu) {
        this.config.featured = menu.page
      }
    },
  },
  methods: {
    isValid() {
      const leftListValid = !this.$refs.leftList || this.$refs.leftList.isValid()
      const rightListValid = !this.$refs.rightList || this.$refs.rightList.isValid()
      return leftListValid && rightListValid
    },
    onAddMenuItem() {
      if (!this.canCDMenuEdit) {
        return
      }

      const newItemId = uuid.v4()
      this.config.left.push({
        id: newItemId,
        enabled: true,
        page: "",
        label: "",
        labelEs: "",
        displayType: "text",
        amazon: true,
        android: true,
        chromecast: true,
        playstation: true,
        roku: true,
        tvos: true,
        xbox: true,
      })
      // Auto expand the form for the new menu item.
      this.$nextTick(() => {
        this.$root.$emit("bv::toggle::collapse", newItemId)
      })
    },
    onRemoveMenuItem(idToRemove) {
      if (!this.canCDMenuEdit) {
        return
      }

      const vm = this
      const menuItemToRemove = vm.allMenuItems.find(it => it.id === idToRemove)
      if (!menuItemToRemove) {
        return
      }

      vm.confirmRemoval({ id: menuItemToRemove.page }, () => {
        if (vm.featuredMenuId === idToRemove) {
          vm.featuredMenuId = null
        }
        vm.config.left = vm.config.left.filter(it => it.id !== idToRemove)
        vm.config.right = vm.config.right.filter(it => it.id !== idToRemove)
      })
    },
  },
}
</script>

<style scoped>

</style>
